import { ExpenseItemEdit } from '@client/components/financials/expense-items/ExpenseItemEdit';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { claimFormStore } from '../store';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/expenses/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New expense item',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const claim = claimFormStore.use.formData();
    const isReadonly = claimFormStore.use.isReadonly();
    const navigate = useNavigate();

    useEffect(() => {
        if (isReadonly) {
            navigate({ moveInMatches: -1 });
        }
    }, [isReadonly]);

    return (
        <ExpenseItemEdit
            action={['add']}
            insurerId={claim.insurerId}
            handlingPartyIds={claim.HandlingParties.map(({ id }) => id)}
        />
    );
}
